import { Component, Input, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { LocaleAwareBaseComponent } from '../../common-theme';
import { AgencyService } from '../../common-theme/api';
import { MenuLink } from '../../common-theme/base-components/shared/menu/menu-link.model';

@Component({
  selector: 'app-menu-container',
  templateUrl: './menu-container.component.html',
  styleUrls: ['./menu-container.component.scss']
})

export class MenuContainerComponent extends LocaleAwareBaseComponent implements OnInit {
  @Input() links: MenuLink[];
  @Input() hasLogo: boolean = true;
  @Input() hasSocialLinks: boolean = true;
  @Input() hasPhoneNumber: boolean = false;
  @Input() currentRoute: string;
  public open: boolean;

  constructor(
    public agencyService: AgencyService,
    @Inject(DOCUMENT) public document: any
  ) {
    super();
  }

  ngOnInit(): void {
    if (!this.links || this.links.length === 0) {
      throw new Error('MenuContainerBaseComponent Error: Invalid links');
    }
  }

  public toggleMobileMenu(): void {
    this.open = !this.open;

    if (this.open) {
      this.document.body.classList.add('no-scroll');
    } else {
      this.document.body.classList.remove('no-scroll');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/menu-container/menu-container.component.ts